import Moment from 'moment';
import { extendMoment } from 'moment-range';
import {
  setRoundsPlayed,
  setSharkGroupsData,
  setSharkAllGroups,
  setSharkScreensData,
  setSharkUniqueRentalData,
  setSharkAnalyticsData,
} from './sharkMutations';

const moment = extendMoment(Moment);

// mutations
const mutations = {
  setSessions(state, payload) {
    state.sessions = payload;
  },
  setTab(state, payload) {
    state.tab = payload;
  },
  setScreens(state, payload) {
    state.reportsScreens = payload;
  },
  setChargedOffSessions(state, payload) {
    state.chargedOffSessions = payload;
  },
  setGroups(state, payload) {
    const allGroups = [];
    const nullGroups = [];
    payload.map(group => {
      if (group.last_activity != null) {
        allGroups.push(group);
      } else {
        nullGroups.push(group);
      }
    });
    allGroups.sort(
      (a, b) => parseFloat(b.last_activity) - parseFloat(a.last_activity)
    );
    nullGroups.map(group => {
      allGroups.push(group);
    });
    state.groups = allGroups;
  },
  setQueryParams(state, payload) {
    state.queryParams = payload;
  },
  setExport(state, payload) {
    state.export = payload;
  },
  setRentalTypeChart(state, payload) {
    state.chartData.rentalData.data = payload;
  },
  setChargedOffRentalTypeChart(state, payload) {
    state.chartData.chargedOffRentalData.data = payload;
  },
  setRentalsByWeek(state, payload) {
    state.chartData.rentalsByWeek.data[0].data = payload;
  },
  setRentalsByDay(state, payload) {
    state.chartData.rentalsByDay.data[0].data = payload;
  },
  setCheckedInChart(state, payload) {
    state.chartData.checkedIn.overdue = payload.overdue;
    state.chartData.checkedIn.data = payload.chartData;
  },
  setUtilizationChart(state, payload) {
    const chart = {};
    chart.chartType = 'line';
    chart.showOnMobile = true;
    chart.type = 'line-chart';
    chart.component = 'chart';
    chart.width = '100%';
    chart.title = 'Utilization';
    chart.data = [
      {
        data: [],
        name: chart.title,
      },
    ];
    chart.labels = [];
    const newstart = moment(payload.filter.start_date);
    const newend = moment(payload.filter.end_date);
    const range = moment.range(newstart, newend);
    let format = 'YYYY';
    const years = Array.from(range.by('year'));
    let timeValues = years;
    let timeValue = 'y';
    if (years.length <= 2) {
      const months = Array.from(range.by('month'));
      timeValues = months;
      timeValue = 'M';
      format = 'MMMM';
      if (months.length <= 4) {
        const weeks = Array.from(range.by('week'));
        timeValues = weeks;
        timeValue = 'w';
        format = 'MM-DD';
        if (weeks.length <= 2) {
          const days = Array.from(range.by('day'));
          timeValues = days;
          timeValue = 'd';
          format = 'MM-DD';
          if (days.length <= 2) {
            const hours = Array.from(range.by('hour'));
            timeValues = hours;
            timeValue = 'h';
            format = 'HH:mm';
          }
        }
      }
    }
    const allRanges = [];
    timeValues.map((time, index) => {
      if (timeValues[index + 1]) {
        const range = moment.range(time, timeValues[index + 1]);
        allRanges.push(range);
      } else {
        const range = moment.range(time, moment(time).add(1, timeValue));
        allRanges.push(range);
      }
    });
    allRanges.map((range, index) => {
      const uniqueScreenIds = [];
      if (payload.data.length > 0) {
        chart.data[0].data[index] = 0;
        payload.data.map(session => {
          if (
            session.screen_id &&
            range.contains(moment(session.end_at * 1000)) &&
            uniqueScreenIds.indexOf(session.screen_id) < 0
          ) {
            uniqueScreenIds.push(session.screen_id);
          }
        });
      }
      let percent = Math.round(
        (uniqueScreenIds.length / payload.screenCount) * 100
      );
      if (percent === 0) {
        percent = 1;
      }
      chart.data[0].data[index] = percent;
    });
    const timeLabels = timeValues.map(m => m.format(format));
    chart.labels = timeLabels;
    state.chartData.deviceUtilization = chart;
  },
  setExportURL(state, payload) {
    state.exportURL = payload;
  },
  setLastEvalKey(state, payload) {
    state.lastEvalKey = payload;
  },
  setTempSessions(state, payload) {
    state.tempSessions = payload;
  },
  setRoundsPlayedChart(state, payload) {
    state.roundsPlayedChart = payload;
  },
  setLaunchModeChart(state, payload) {
    state.launchModeChart = payload;
  },
  setCarsByModelGraph(state, payload) {
    state.carsByModelGraph = payload;
  },
  setTotalCarsGraph(state, payload) {
    state.totalCarsGraph = payload;
  },
  setGroupsByModelGraph(state, payload) {
    state.groupsByModelGraph = payload;
  },
  setTotalGroupsGraph(state, payload) {
    state.totalGroupsGraph = payload;
  },
  setSharkAnalytics(state, payload) {
    state.sharkAnalytics = payload;
  },
  setRoundsTableLoading(state, payload) {
    state.roundsTableLoading = payload;
  },
  setScreensTableLoading(state, payload) {
    state.screensTableLoading = payload;
  },
  setGroupsTableLoading(state, payload) {
    state.groupsTableLoading = payload;
  },
  setRounds(state, payload) {
    state.rounds = payload;
  },
  setDynamicYardageChart(state, payload) {
    state.dynamicYardageChart = payload;
  },
  setScorecardData(state, payload) {
    state.scorecardChart = payload;
  },
  setFoodAndBeverageGraph(state, payload) {
    state.foodAndBeverageChart = payload;
  },
  setListenChart(state, payload) {
    state.listenChart = payload;
  },
  setWatchChart(state, payload) {
    state.watchChart = payload;
  },
  setGraphLoadingState(state, payload) {
    state.graphLoadingStates[payload.name] = payload.value;
  },
  setRoundsPlayed,
  setSharkGroupsData,
  setSharkAllGroups,
  setSharkScreensData,
  setSharkUniqueRentalData,
  setSharkAnalyticsData,
};
export default mutations;
